var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSplash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 947,
    height: 1024,
    viewBox: "0 0 947 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11326_41026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 947,
    height: 1024,
    fill: "url(#paint0_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11326_41026)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M6.10352e-05 1024L951.954 1024L951.954 602C951.954 602 663.321 792.614 387.636 780.127C266.801 774.775 135.812 718.967 0.507844 665.963",
    fill: "#67ABF2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M6.10352e-05 1024L951.954 1024L951.954 666.472C809.542 623.916 665.098 599.707 523.955 637.167C276.955 702.913 199.783 762.289 0.507833 788.536L6.10352e-05 1024Z",
    fill: "#0078EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.388 974.053C498.062 997.498 435.614 1013.3 380.274 1024L951.954 1024L951.954 999.281C829.85 962.841 705.969 941.944 585.388 974.053Z",
    fill: "#67ABF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.746 804.259C919.968 808.336 877.574 810.375 821.98 809.865C593.511 807.571 427.744 702.581 261.724 706.913C95.703 711.245 2.7923 783.617 2.7923 783.617",
    stroke: "#67ABF2",
    strokeWidth: 1.01,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.76 495.44C379.04 477.56 472.4 465.2 536.72 475.16C560.36 478.88 570.2 503.6 570.56 504.32V530.84C570.576 530.904 570.566 530.971 570.532 531.027C570.498 531.084 570.444 531.124 570.38 531.14C570.316 531.156 570.249 531.146 570.193 531.112C570.136 531.078 570.096 531.024 570.08 530.96C567.8 525.92 557.6 506.24 536.72 503C474.44 493.28 384.8 504.56 377.24 521.6C377.12 521.84 376.76 521.84 376.76 521.48V495.44Z",
    fill: "url(#paint1_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.08 443.72C555.08 443.084 554.827 442.473 554.377 442.023C553.927 441.573 553.317 441.32 552.68 441.32H539.36L555.08 457.04V443.72Z",
    fill: "url(#paint2_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.32 437.96L510.08 582.08V582.32L553.4 541.28C553.922 540.784 554.339 540.189 554.628 539.53C554.916 538.87 555.07 538.16 555.08 537.44V457.04L539.36 441.32H537.92C528.2 441.32 518.6 442.52 510.32 437.96Z",
    fill: "url(#paint3_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.96 427.64L478.4 416.36C476.974 415.426 475.305 414.928 473.6 414.928C471.895 414.928 470.227 415.426 468.8 416.36L437.72 437.12C429.08 442.76 419 441.32 408.68 441.32H401.6L401.36 520.64L494.96 427.64Z",
    fill: "url(#paint4_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.08 582.32V582.08L510.32 437.96L508.64 436.88L494.96 427.64L401.36 520.64L485.84 605.36L510.08 582.32Z",
    fill: "url(#paint5_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.24 530.12V537.44C392.25 538.16 392.404 538.87 392.692 539.53C392.981 540.189 393.398 540.784 393.92 541.28L461.48 605.36C464.761 608.492 469.124 610.24 473.66 610.24C478.196 610.24 482.559 608.492 485.84 605.36L401.36 520.64L392.24 530.12Z",
    fill: "url(#paint6_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6 441.32H394.52C393.904 441.351 393.324 441.617 392.9 442.064C392.476 442.511 392.239 443.104 392.24 443.72V510.08L401.36 520.64L401.6 441.32Z",
    fill: "url(#paint7_linear_11326_41026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.56 531.32C559.76 545.48 545.48 524.48 516.32 512.96C487.16 501.44 476.36 527.24 445.88 541.4C415.4 555.56 376.76 522.44 376.76 522.44V495.32C376.76 495.32 415.4 528.56 445.88 514.28C476.36 500 487.16 474.32 516.32 485.84C545.48 497.36 559.76 518.36 570.56 504.2V531.32Z",
    fill: "url(#paint8_linear_11326_41026)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11326_41026",
    x1: 473.5,
    y1: 0,
    x2: 473.5,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#182B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F447E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11326_41026",
    x1: 376.712,
    y1: 501.332,
    x2: 570.536,
    y2: 501.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#807F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11326_41026",
    x1: 510.43,
    y1: 448.979,
    x2: 619.078,
    y2: 449.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11326_41026",
    x1: 510.323,
    y1: 509.998,
    x2: 618.971,
    y2: 510.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11326_41026",
    x1: 401.617,
    y1: 467.581,
    x2: 510.397,
    y2: 467.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4298F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#53A0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5EA7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#65AAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#67ABF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11326_41026",
    x1: 401.532,
    y1: 516.18,
    x2: 510.312,
    y2: 516.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11326_41026",
    x1: 267.599,
    y1: 565.039,
    x2: 510.226,
    y2: 565.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4B9CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5FA7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67ABF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11326_41026",
    x1: 2537.64,
    y1: 21136.9,
    x2: 3534.1,
    y2: 21138.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3390EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11326_41026",
    x1: 416.192,
    y1: 455.876,
    x2: 531.188,
    y2: 570.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11326_41026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 947,
    height: 1024,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11326_41026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 955,
    height: 422,
    fill: "white",
    transform: "translate(955 1024) rotate(-180)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.d1478fe89daf8ec57eb64aca137651fd.svg";
export { ForwardRef as ReactComponent };